import { FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { BooleanSelectOption } from '@yard/utils/boolean-select.util'
import { observer } from 'mobx-react-lite'
import { FieldStore } from 'modules/utils/src/stores/formStore/FieldStore'

interface Props {
  label: string
  field: FieldStore<BooleanSelectOption | undefined>
}
export const AllocationRuleFacetBooleanSelect = observer(({ label, field }: Props) => {
  const { t } = useTranslate()

  return (
    <FormControl fullWidth>
      <InputLabel error={!!field.error}>{label}</InputLabel>

      <Select {...field.props} label={label}>
        <MenuItem value={BooleanSelectOption.True}>{label}</MenuItem>
        <MenuItem value={BooleanSelectOption.False}>
          {t('nonField', 'Non {field}', { field: label })}
        </MenuItem>
      </Select>

      {field.error && (
        <Typography variant='caption' color='error'>
          {t(field.error)}
        </Typography>
      )}
    </FormControl>
  )
})
